import React, { FC, memo, useContext, useMemo } from 'react'
import { ScreenContext } from 'react-components'

import {
    Container,
    InnerContainer,
    HeadingWrapper,
    Heading,
    Subheading,
    CardsContainer,
    StyledCarouselProvider,
    StyledSlider,
    StyledSlide,
} from './styles'
import { TipSectionTransport } from '../../../transports/region-landing-page-transport'
import { useTranslation } from '../../../hooks/locale'
import TipsSectionCard from './tips-section-card'

interface TipsProps {
    tipsSection: TipSectionTransport
    location: string
}

const TipsSection: FC<TipsProps> = ({ tipsSection, location }) => {
    const { heading, tips } = tipsSection
    const { t } = useTranslation()
    const { isDesktop, isMobile } = useContext(ScreenContext)

    const tipsSectionHeading = heading ? heading : `${t('tipsSectionHeading')} ${location}`
    const subheading = `${t('tipsSectionSubHeading')}${location}`

    const tipsSectionItems = useMemo(
        () =>
            tips.map((tip, index) => {
                return !isDesktop ? (
                    <StyledSlide key={tip.title} index={index}>
                        <TipsSectionCard tip={tip} location={location} />
                    </StyledSlide>
                ) : (
                    <TipsSectionCard key={tip.title} tip={tip} location={location} />
                )
            }),
        [tips, location, isDesktop],
    )

    return (
        <Container>
            <InnerContainer>
                <HeadingWrapper>
                    <Heading>{tipsSectionHeading}</Heading>
                    <Subheading>{subheading}</Subheading>
                </HeadingWrapper>

                <CardsContainer>
                    {!isDesktop ? (
                        <StyledCarouselProvider
                            totalSlides={tipsSectionItems.length}
                            visibleSlides={isMobile ? 1.1 : 2}
                            naturalSlideWidth={1}
                            naturalSlideHeight={1}
                            isIntrinsicHeight
                            lockOnWindowScroll
                            dragStep={1}
                            step={1}
                        >
                            <StyledSlider>{tipsSectionItems}</StyledSlider>
                        </StyledCarouselProvider>
                    ) : (
                        tipsSectionItems
                    )}
                </CardsContainer>
            </InnerContainer>
        </Container>
    )
}

export default memo(TipsSection)
